import styles from './styles.module.scss'
import Asset from '../Asset'
import trashImg from '../ComputerAndTrash/images/Lixeira.png';
import dropAreaImg from './dropArea.png'
import dragBoxImg from './alternativa.png'
import videoImg from '../../assets/images/icons/logicmaker/video.png'
import png from '../../assets/images/icons/logicmaker/png.png'

export default function AssetsList() {
    return (
        <div id="assetsList" className={styles.assetsList}>
            <div className={styles.list}>
                  <Asset image={"https://cdn-icons-png.flaticon.com/512/0/99.png"} name="texto"/>
                  <Asset image={dropAreaImg} name={"Campo"}/>
                  <Asset image={dragBoxImg} name={"Alternativa"}/>
                  <Asset image={trashImg} name={"Lixeira"}/>
                  {//<Asset image={checkBoxImg} name={"checkBox"}/>
                  }
                  <Asset image={png} name="imagem"/>
                  <Asset image={videoImg} name="video"/>
            </div>
        </div>
    )
}